var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_916_615)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "#F8F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M128.5 61.9955C128.5 64.4385 127.155 66.9556 124.302 69.4305C121.453 71.902 117.242 74.1959 111.91 76.1522C101.257 80.0606 86.4394 82.5077 70 82.5077C53.5606 82.5077 38.7435 80.0606 28.0902 76.1522C22.7576 74.1959 18.5473 71.902 15.698 69.4305C12.8446 66.9556 11.5 64.4385 11.5 61.9955C11.5 59.5525 12.8446 57.0354 15.698 54.5606C18.5473 52.0891 22.7576 49.7952 28.0902 47.8388C38.7435 43.9305 53.5606 41.4834 70 41.4834C86.4394 41.4834 101.257 43.9305 111.91 47.8388C117.242 49.7952 121.453 52.0891 124.302 54.5606C127.155 57.0354 128.5 59.5525 128.5 61.9955Z",
    stroke: "url(#paint0_linear_916_615)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M128.5 78.0043C128.5 80.4473 127.155 82.9644 124.302 85.4393C121.453 87.9108 117.242 90.2047 111.91 92.161C101.257 96.0694 86.4394 98.5164 70 98.5164C53.5606 98.5164 38.7435 96.0694 28.0902 92.161C22.7576 90.2047 18.5473 87.9108 15.698 85.4393C12.8446 82.9644 11.5 80.4473 11.5 78.0043C11.5 75.5613 12.8446 73.0442 15.698 70.5693C18.5473 68.0979 22.7576 65.804 28.0902 63.8476C38.7435 59.9393 53.5606 57.4922 70 57.4922C86.4394 57.4922 101.257 59.9393 111.91 63.8476C117.242 65.804 121.453 68.0979 124.302 70.5693C127.155 73.0442 128.5 75.5613 128.5 78.0043Z",
    stroke: "url(#paint1_linear_916_615)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M106.25 26.3132C108.364 27.5343 109.87 29.9576 110.586 33.6676C111.3 37.3724 111.181 42.1677 110.208 47.7667C108.264 58.9522 102.973 73.015 94.7535 87.2599C86.5337 101.505 77.007 113.121 68.2973 120.398C63.9376 124.04 59.8469 126.542 56.2829 127.775C52.714 129.01 49.8634 128.916 47.7495 127.695C45.6356 126.474 44.1293 124.051 43.4138 120.341C42.6993 116.636 42.819 111.841 43.792 106.242C45.7358 95.0562 51.0263 80.9934 59.2461 66.7484C67.4659 52.5035 76.9927 40.8878 85.7023 33.6107C90.0621 29.9681 94.1527 27.4668 97.7167 26.2335C101.286 24.9985 104.136 25.0921 106.25 26.3132Z",
    stroke: "url(#paint2_linear_916_615)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M106.272 113.669C104.158 114.889 101.307 114.982 97.7372 113.747C94.1723 112.514 90.0805 110.012 85.7194 106.37C77.0071 99.0935 67.477 87.479 59.2538 73.236C51.0306 58.9931 45.7373 44.9325 43.7917 33.7491C42.8179 28.1512 42.6976 23.3569 43.4118 19.6529C44.127 15.9437 45.6334 13.5212 47.7475 12.3006C49.8617 11.0799 52.7129 10.9867 56.2827 12.2219C59.8476 13.4553 63.9394 15.9566 68.3005 19.599C77.0128 26.8756 86.5429 38.49 94.7661 52.733C102.989 66.976 108.283 81.0365 110.228 92.2199C111.202 97.8179 111.322 102.612 110.608 106.316C109.893 110.025 108.387 112.448 106.272 113.669Z",
    stroke: "url(#paint3_linear_916_615)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5 69.9994C128.5 72.4424 127.155 74.9595 124.302 77.4344C121.453 79.9059 117.242 82.1998 111.91 84.1561C101.257 88.0645 86.4394 90.5116 70 90.5116C53.5606 90.5116 38.7435 88.0645 28.0902 84.1561C22.7576 82.1998 18.5473 79.9059 15.698 77.4344C12.8446 74.9595 11.5 72.4424 11.5 69.9994C11.5 67.5564 12.8446 65.0393 15.698 62.5645C18.5473 60.093 22.7576 57.7991 28.0902 55.8427C38.7435 51.9344 53.5606 49.4873 70 49.4873C86.4394 49.4873 101.257 51.9344 111.91 55.8427C117.242 57.7991 121.453 60.093 124.302 62.5645C127.155 65.0393 128.5 67.5564 128.5 69.9994Z",
    stroke: "url(#paint4_linear_916_615)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2501 19.3093C101.364 20.5304 102.87 22.9536 103.586 26.6637C104.3 30.3685 104.181 35.1638 103.208 40.7628C101.264 51.9483 95.9733 66.0111 87.7535 80.256C79.5337 94.501 70.007 106.117 61.2973 113.394C56.9376 117.036 52.8469 119.538 49.2829 120.771C45.714 122.006 42.8634 121.912 40.7495 120.691C38.6356 119.47 37.1293 117.047 36.4138 113.337C35.6993 109.632 35.819 104.837 36.792 99.2377C38.7358 88.0523 44.0263 73.9895 52.2461 59.7445C60.4659 45.4995 69.9927 33.8839 78.7023 26.6068C83.0621 22.9642 87.1527 20.4629 90.7167 19.2296C94.2857 17.9945 97.1363 18.0882 99.2501 19.3093Z",
    stroke: "url(#paint5_linear_916_615)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M92.2501 15.3064C94.364 16.5275 95.8703 18.9507 96.5859 22.6607C97.3004 26.3656 97.1807 31.1608 96.2077 36.7599C94.2639 47.9453 88.9733 62.0081 80.7535 76.2531C72.5337 90.498 63.007 102.114 54.2973 109.391C49.9376 113.033 45.8469 115.535 42.2829 116.768C38.714 118.003 35.8634 117.909 33.7495 116.688C31.6356 115.467 30.1293 113.044 29.4138 109.334C28.6993 105.629 28.819 100.834 29.792 95.2348C31.7358 84.0493 37.0263 69.9865 45.2461 55.7416C53.4659 41.4966 62.9927 29.8809 71.7023 22.6039C76.0621 18.9613 80.1527 16.4599 83.7167 15.2266C87.2857 13.9916 90.1363 14.0852 92.2501 15.3064Z",
    stroke: "url(#paint6_linear_916_615)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2505 120.691C97.1366 121.912 94.286 122.006 90.7171 120.771C87.1531 119.538 83.0624 117.036 78.7027 113.394C69.993 106.117 60.4663 94.5009 52.2465 80.2559C44.0267 66.0109 38.7361 51.9482 36.7923 40.7627C35.8193 35.1636 35.6996 30.3684 36.4141 26.6636C37.1297 22.9535 38.636 20.5303 40.7499 19.3092C42.8637 18.0881 45.7143 17.9944 49.2833 19.2295C52.8473 20.4627 56.9379 22.9641 61.2977 26.6067C70.0073 33.8837 79.5341 45.4994 87.7539 59.7444C95.9737 73.9894 101.264 88.0521 103.208 99.2376C104.181 104.837 104.301 109.632 103.586 113.337C102.871 117.047 101.364 119.47 99.2505 120.691Z",
    stroke: "url(#paint7_linear_916_615)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M92.2505 124.693C90.1366 125.914 87.286 126.008 83.7171 124.773C80.1531 123.54 76.0624 121.038 71.7027 117.396C62.993 110.119 53.4663 98.5028 45.2465 84.2579C37.0267 70.0129 31.7361 55.9501 29.7923 44.7646C28.8193 39.1656 28.6996 34.3703 29.4141 30.6655C30.1297 26.9555 31.636 24.5323 33.7499 23.3111C35.8637 22.09 38.7143 21.9964 42.2833 23.2314C45.8473 24.4647 49.9379 26.966 54.2977 30.6087C63.0073 37.8857 72.5341 49.5014 80.7539 63.7463C88.9737 77.9913 94.2642 92.0541 96.208 103.24C97.181 108.839 97.3007 113.634 96.5862 117.339C95.8707 121.049 94.3644 123.472 92.2505 124.693Z",
    stroke: "url(#paint8_linear_916_615)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1623 57.5875L84.324 69.9988L77.1623 82.4101L62.8388 82.4101L55.6771 69.9988L62.8388 57.5875L77.1623 57.5875Z",
    fill: "#3AEFEF",
    stroke: "url(#paint9_linear_916_615)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1511 64.5357L76.3033 69.9985L73.1511 75.4612L66.8468 75.4612L63.6946 69.9985L66.8468 64.5357L73.1511 64.5357Z",
    fill: "url(#paint10_linear_916_615)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_916_615",
    x1: 10,
    y1: 80.099,
    x2: 129.058,
    y2: 59.3022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_916_615",
    x1: 10,
    y1: 96.1077,
    x2: 129.058,
    y2: 75.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_916_615",
    x1: 62.6692,
    y1: 138.046,
    x2: 104.217,
    y2: 24.4908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_916_615",
    x1: 31.326,
    y1: 20.0495,
    x2: 108.909,
    y2: 112.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_916_615",
    x1: 10,
    y1: 88.1029,
    x2: 129.058,
    y2: 67.3061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_916_615",
    x1: 55.6692,
    y1: 131.042,
    x2: 97.2167,
    y2: 17.4869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_916_615",
    x1: 48.6692,
    y1: 127.039,
    x2: 90.2167,
    y2: 13.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_916_615",
    x1: 24.3308,
    y1: 27.0617,
    x2: 101.928,
    y2: 119.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_916_615",
    x1: 17.3308,
    y1: 31.0636,
    x2: 94.9279,
    y2: 123.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_916_615",
    x1: 51.7061,
    y1: 73.0406,
    x2: 77.9078,
    y2: 86.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_916_615",
    x1: 61.9468,
    y1: 71.3373,
    x2: 73.4793,
    y2: 77.0422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_916_615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.0b8a0c79b83235540a2f6058c45150ba.svg";
export { ForwardRef as ReactComponent };